import { render, staticRenderFns } from "./mstrrubrik.vue?vue&type=template&id=4edfe51e"
import script from "./mstrrubrik.vue?vue&type=script&lang=js"
export * from "./mstrrubrik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports